import {IsNotEmpty} from "class-validator";

export class Login {

    @IsNotEmpty({message: "Informe o usuário."})
    usuario: string;

    @IsNotEmpty({message: "Informe a senha."})
    senha: string;
}